import { uuid } from "@/utils";

// 考试提交状态管理
const ExamStatusHelper = {
    methods: {
        // 生成考试UUID 并且设置提交状态为false
        genExamUuidAndStartExamStatus() {
            let _uid = uuid()
            this.writExamStatus(_uid, false)
            return _uid;
        },
        writExamStatus(examUuid, haveSubmit = false) {
            window.localStorage.setItem(`exam-${examUuid}`, JSON.stringify({
                haveSubmit: haveSubmit
            }))
        },
        readExamSubmitted(examUuid) {
            let json = window.localStorage.getItem(`exam-${examUuid}`)
            json = JSON.parse(json)
            return json.haveSubmit
        }
    },
};

export { ExamStatusHelper }
